import * as React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Link,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useLanguage } from "./Language";

interface MARCDialogProps {
  resourceId: number;
}

const MARCDialog: React.FC<MARCDialogProps> = ({ resourceId }) => {
  const [open, setOpen] = React.useState(false);

  const { translate } = useLanguage();
  const iframeRef = React.useRef(null);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const handlePrint = () => {
    if (iframeRef.current) {
      iframeRef.current.contentWindow.focus();
      iframeRef.current.contentWindow.print();
    }
  };

  const onClose = () => {
    setOpen(false);
  };

  const iframeSrc = "marcrecordview?resourceId=" + resourceId;

  return (
    <React.Fragment>
      <Link underline="hover" component="button" onClick={() => setOpen(true)}>
        <small>{translate("marcRecord")}</small>
      </Link>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="lg"
        fullScreen={fullScreen}
        fullWidth
      >
        <DialogTitle>{translate("marcRecord")}</DialogTitle>
        <DialogContent>
          <iframe
            ref={iframeRef}
            src={iframeSrc}
            title={translate("marcRecord")}
            style={{
              width: "100%",
              height: fullScreen
                ? "calc(100vh - 150px)"
                : "calc(100vh - 300px)", // 150px / 300px sweet spot through trial and error (accounts for vertical positioning, DialogTitle, DialogActions and padding/margins)
              border: "none",
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Close
          </Button>
          <Button onClick={handlePrint} color="primary" variant="contained">
            Print
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default MARCDialog;
